import { graphql } from 'react-relay';

export const cutOffListDownloadFragment = graphql`
    fragment CutOffListDownload_cutOffListDownload on SimpleLink {
        label
        url
    }
`;
